<template>
  <div class="flow-db-record-approval-history"
       v-loading="loading"
       element-loading-text="加载中...">
    <template v-if="historyInfo">
      <div class="history-toolbar">
        <span class="toolbar-title">流转记录</span>
        <el-radio-group v-model="useTimeline" size="mini">
          <el-radio-button :label="false"><i class="el-icon-share"></i> 结构视图</el-radio-button>
          <el-radio-button :label="true"><i class="el-icon-time"></i> 时间线视图</el-radio-button>
        </el-radio-group>
      </div>
      <div class="history-main">
        <div class="history-body">
          <AppScrollbar style="height: 100%">
            <div class="flow-history-container">
              <FlowCommonHistory :history-info="historyInfo" :timeline="useTimeline"></FlowCommonHistory>
            </div>
          </AppScrollbar>
        </div>
      </div>
    </template>
    <template v-else-if="!loading">
      <Hint type="error">
        <div>流转记录加载失败</div>
        <el-button size="mini" type="text" @click="loadHistoryInfo">重新加载</el-button>
      </Hint>
    </template>
  </div>
</template>

<script>
import AppScrollbar from '../../../../../../elements/AppScrollbar'
import Hint from '../../../../../../elements/Hint'
import FlowCommonHistory from '../../../../../flow/common/approval/history'
export default {
  name: 'FlowDbRecordApprovalHistory',
  components: {
    AppScrollbar,
    Hint,
    FlowCommonHistory
  },
  props: {
    id: {
      type: String,
      required: true
    },
    active: Boolean
  },
  data () {
    return {
      loading: false,
      historyInfo: null,
      useTimeline: false
    }
  },
  methods: {
    loadHistoryInfo () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/flow/db/record/process/history',
        method: 'post',
        data: this.$qs.stringify({ id: this.id })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.historyInfo = response.data.historyInfo || {}
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    }
  },
  mounted () {
    this.loadHistoryInfo()
  },
  watch: {
    active (val) {
      if (val) {
        this.loadHistoryInfo()
      }
    }
  }
}
</script>

<style lang="scss">
.flow-db-record-approval-history {
  height: 100%;
  background-color: #fff;
  display: flex;
  flex-direction: column;

  .history-toolbar {
    flex: none;
    padding: 16px 16px 2px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .toolbar-title {
      font-size: 13px;
      font-weight: 500;
      color: #303133;
    }

    .el-radio-group {
      .el-radio-button:first-child .el-radio-button__inner {
        border-radius: 30px 0 0 30px;
      }

      .el-radio-button:last-child .el-radio-button__inner {
        border-radius: 0 30px 30px 0;
      }
    }
  }

  .history-main {
    flex: auto;
    position: relative;

    &>.history-body {
      position: absolute;
      inset: 0;

      .flow-history-container {
        padding: 16px 20px;
      }
    }
  }
}
</style>
